import React__default from"react";
/**
 * A utility type for creating polymorphic components.
 * 
 * Allows a component to accept the props of another component or element,
 * omitting those which conflict with the polymorphic component.
 */
/**
 * This Typescript utility transform a list of slots into a list of {slot: classes}
 * @example
 * ```ts
 * const styles = pdsTv({
 *   slots: {
 *    base: "...",
 *    card: "...",
 *   }, 
 * });

 * export type YourTypeSlots = keyof ReturnType<typeof styles>;
 * type YourType = SlotsToClasses<YourTypeSlots>; // should be { base?: string, card?: string }
 *
 * Inside your component:
 * { classNames: SlotsToClasses<YourTypeSlots> }
 * ```
 */function useDOMRef(ref){var domRef=React__default.useRef(null);return React__default.useImperativeHandle(ref,(function(){return domRef.current})),domRef}export{useDOMRef};
//# sourceMappingURL=utils.js.map
